"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.create = void 0;
const SdPlatformSdk_1 = require("./SdPlatformSdk");
function create(clientId, clientSecret, baseUrl) {
    const checkIfCredential = (clientId) => {
        return !!(clientId && clientId.clientId);
    };
    if (checkIfCredential(clientId)) {
        return new SdPlatformSdk_1.SdPlatformSdk(clientId.clientId, clientId.clientSecret, clientId.baseUrl);
    }
    else if (clientId) {
        return new SdPlatformSdk_1.SdPlatformSdk(clientId, clientSecret, baseUrl);
    }
    else {
        throw new Error("Parameter clientId must be provided.");
    }
}
exports.create = create;
//# sourceMappingURL=SdPlatformSdkCreate.js.map